import ErrorBoundary from 'components/_shared/ErrorBoundary/ErrorBoundary';

export default ErrorBoundary;
